import { Link } from "react-router-dom";
import type { CastItem } from "@/types/content";

export default function CastCard({ item }: { item: CastItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col items-center rounded-lg border border-background-300 bg-background-50 p-5 text-center transition-colors hover:border-primary-300"
    >
      <div className="h-24 w-24 overflow-hidden rounded-full border border-background-200">
        <img
          src={item.avatar}
          alt={item.actor}
          title={`${item.actor} 饰 ${item.roleName} - 我的朋友他的妻子演员信息`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <span className="mt-3 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
        {item.category}
      </span>
      <h3 className="mt-2 text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
        {item.actor}
      </h3>
      <p className="mt-0.5 text-sm text-primary-600">饰 {item.roleName}</p>
      <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
        {item.intro}
      </p>
    </Link>
  );
}